import { CreateEventForm } from '@/services/Calendar/Events/forms/CreateEventForm';

export class EditEventForm extends CreateEventForm {
}
